import { createSlice } from "@reduxjs/toolkit";
import aboutUsPage from "../Services/AboutUs.Services";

const initialState = {
    getAboutUs: [],
    loading: false,
    error: false,
    success: false,
  };


  const aboutUsSlice = createSlice({
    name: "aboutUs",
    initialState,
    // reducers: {
    //   setCmsPageInfo: (state, action) => {
    //     state.cmsPages = action?.payload?.cmsPages;
    //   },
    //   setSuccess: (state, action) => {
    //     state.success = action?.payload;
    //   },
    // },
    extraReducers: {
      [aboutUsPage.pending]: (state, action) => {
        state.loading = true;
      },
      [aboutUsPage.fulfilled]: (state, action) => {
        state.getAboutUs = action.payload?.aboutUs;
        state.loading = false;
      },
      [aboutUsPage.rejected]: (state, action) => {
        state.getAboutUs = action.payload?.aboutUs;
        state.loading = false;
      },
    },
  });
  export const { aboutUs } = aboutUsSlice.actions;
  export default aboutUsSlice.reducer;
    